export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="bg-background-50 border border-background-200/70 rounded-lg p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              手机追番更便捷
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              无需下载APP，直接用手机浏览器访问91樱花动漫即可享受流畅的高清动漫在线观看体验。移动端已做全面适配，随时随地打开浏览器就能追番。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-android-line text-accent-500"></i>
                </div>
                <span>安卓浏览器</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-line text-accent-500"></i>
                </div>
                <span>iOS Safari</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-computer-line text-accent-500"></i>
                </div>
                <span>PC端浏览器</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 md:w-56 aspect-[9/16] rounded-lg overflow-hidden border-2 border-background-300">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20mobile%20phone%20screen%20mockup%20showing%20an%20anime%20streaming%20interface%20with%20thumbnails%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20modern%20UI%20design%2C%20minimalist%20layout%2C%20no%20text%20visible%2C%20app%20interface%20concept&width=480&height=854&seq=app-mobile-preview&orientation=portrait"
                alt="91樱花动漫手机追番界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}